<template>
    <!-- <div> -->
    <contratos
        :dataServicos="obterDataServicos()"
        rotaDetalhar="Gescon_Gestores_Contratos_Detalhar"
        rotaListagem="Gescon_Gestores_Contratos"
        :permiteDetalhar="$temAcessoView('GESCON-GEST-CONT-00')"
    ></contratos>
    <!-- </div> -->
</template>

<script>
import ContratosServicos from './ContratosServicos'
import Contratos from '../../contratos/Contratos2'

export default {
    methods: {
        obterDataServicos() {
            return ContratosServicos
        }
    },

    components: {
        Contratos
    }
}
</script>
